<template>
<div class="loginpage">

   <v-container fill-height>
        <v-row justify-center>
            <v-col cols="10" class="mx-auto">
                <v-alert
                v-model="errorsMessage"
                  prominent
                  type="error"
                  dismissible
               >
                  <v-row align="center">
                  <v-col class="grow">
                     Opps something went wrong {{ this.errorMessage }}
                  </v-col>
                  <!-- <v-col class="shrink">
                     <v-btn>Take action</v-btn>
                  </v-col> -->
                  </v-row>
               </v-alert>
               <!-- <v-alert
                v-if="verifiyemailaddress"
                  prominent
                  type="info"
                  dismissible
               >
                  <v-row align="center">
                  <v-col class="grow">
                     User was successfully created. Please see email and follow link to verify your email to complete registration.
                  </v-col>
                  
                  </v-row>
               </v-alert> -->
           </v-col>
            <v-col cols="12" class="text-center" height="100%">
                <v-card
                    elevation="2"
                    max-width="500"
                    class="mx-auto my-auto py-5 px-5 mylogincard"
                >
                <v-row>
                    <v-col class="col-12 text-center">
                        <v-img src="../assets/africanring.jpeg" width="150px" class="mx-auto"/>
                    </v-col>
                </v-row>
                <h1 class="white--text">
                    Login
                </h1>
                <v-form ref="form" v-model="valid">
                    <v-text-field
                    dark
                        :rules="[rules.required]"
                        v-model="email"
                        label="Email Address"
                        required
                    ></v-text-field>
                    <v-text-field
                    dark
                        type="password"
                        :rules="[rules.required]"
                        v-model="password"
                        label="Password"
                        required
                    ></v-text-field>
                    <v-btn
                    :loading="loading"
                    :disabled="!valid"
                    class="ma-2 white--text"
                    color="red"
                    @click="login()"
                    >
                    LOGIN
                    </v-btn>
                </v-form>
                <!-- <v-btn
                    class="ma-2 white--text"
                    color="red"
                    @click="reg()"
                    >
                    REGISTER
                    </v-btn> -->
                </v-card>
            </v-col>
        </v-row>
    </v-container>
    </div>
</template>

<script>
// import { mapGetters } from 'vuex'
import { getAuth, signInWithEmailAndPassword } from "firebase/auth";
import db from '../firebaseConfig'
import { collection, getDocs, addDoc, updateDoc, doc, deleteDoc, getDoc, query, where, setDoc } from "firebase/firestore";

export default {
    data: () => ({
        email: '',
        password: '',
        errorsMessage:false,     
        errorMessage: '',
        rules: {
            required: value => !!value || 'Required.',
        },
        valid: false,
        loading:false,
        thisUseremail:''
    }),
    computed: {
    //   ...mapGetters([
    //     'verifiyemailaddress',
    //   ]),
    },
    methods: {
        validate () {
        this.$refs.form.validate()
      },
      reg() {
        this.$router.replace('register');
      },
        login(){
            this.loading = true
            const auth = getAuth()
             signInWithEmailAndPassword(auth, this.email, this.password)
               .then(async user => {
                   console.log('test', user)
                   this.thisUseremail = user.user.email
                //    console.log('testmemailVerified', user.user.emailVerified)
                   if(!user.user.emailVerified) {
                       this.VerifyQuotes = "You Need to Verify Your Email"
                       this.VerifyMessage = true
                       this.loading = false
                       this.$router.push('/login')
                   } else{
                    console.log('test login', user)

                    const q = query(collection(db, "users"), where("Email", "==", this.thisUseremail));
                    console.log('q', q)
                    
                    const querySnapshot = await getDocs(q);
                    console.log('querySnapshot', querySnapshot)
                    querySnapshot.forEach((doc) => {
                    // doc.data() is never undefined for query doc snapshots
                    let thecurrentuser = doc.data() 
                    console.log('thecurrentuser',thecurrentuser.Role)

                    if(thecurrentuser.Role == "superadmin") {
                        console.log('superadmindoc.Role', thecurrentuser.Role);
                        this.$router.push('/home')
                    }else if(thecurrentuser.Role == "subscriber"){
                        console.log('subscriberdoc.Role', thecurrentuser.Role);
                        this.$router.push('/')
                    }
                    });
                    // this.$router.push('/')
                   }
               })
               .catch(err => {
                this.loading = false
                this.errorsMessage = true
                this.errorMessage = err.message
               });
         },
    }
}

</script>

<style lang="sass">

.loginpage 
  background-image: url("../assets/boxingbg.jpeg")
  background-size: cover
  background-repeat: no-repeat
  background-position-x: center
  height: 100%!important

.mylogincard 
  background-color: #000000!important

</style>